module.exports = __webpack_public_path__ + "static/media/ScrollDownRed.a3f72494.svg";